import React, { Fragment } from 'react'
import * as dotStyles from '../../styles/project-modules/bills/dotplot.module.less'
import * as personStyles from '../../styles/project-modules/bills/person.module.less'
import { range, reverse } from 'd3-array'

const d3 = {
  range: range,
  reverse,
  reverse,
}
const partyMap = {
  1: { label: 'D' },
  2: { label: 'R' },
  3: { label: 'Ind' },
  4: { label: 'G' },
  5: { label: 'L' },
  6: { label: 'Nonpartisan' },
}

function dotPlot({ data, dataLabels, labeledById, groupBy }) {
  const groups = Array.from(new Set(data['vote_details'].map(d => d[groupBy])))
  
  // let formattedData = dataLabels.map(l => )
  return (
    <>
      { !groupBy ? (
        <figure className={dotStyles.dotsContainer} aria-labelled-by={labeledById}>
          {dataLabels.map((d) => (
            <>
              {d3.range(data[d.key]).map(() => (
                <div className={`${dotStyles.dot} ${d.class}`}></div>
              ))}
            </>
          ))}
        </figure>
      ) : (
        <>
          { groups.map((g) => (
            <figure className={`${dotStyles.dotsContainer} ${dotStyles.dotsGroup}`} aria-labelled-by={labeledById}>
              {groupBy == 'party_id' && <span className={personStyles[`party${partyMap[g].label}Dots`]}>{partyMap[g].label}</span>}
              { data['vote_details'].filter(v => v[groupBy] == g).sort((a, b) => a['vote_id'] - b['vote_id']).map((v) => (
                <div className={`${dotStyles.dot} ${dataLabels.find(l => l['type'] == v['vote_id']).class}`}></div>
              ))}
            </figure>
          ))}
          
        </>
      )}
    </>
  )
}

export default dotPlot
